module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sign-in'), _vm._v(" "), _c('div', {
    staticClass: "ui fixed inverted menu"
  }, [_c('div', {
    staticClass: "ui dropdown icon item",
    attrs: {
      "id": "header-menu"
    }
  }, [_c('i', {
    staticClass: "sidebar icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Main")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/movie-times-and-tickets"
    }
  }, [_vm._v("Movie Times & Tickets")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/movies"
    }
  }, [_vm._v("Movies")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/tv"
    }
  }, [_vm._v("TV")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/new-on-dvd"
    }
  }, [_vm._v("New On DVD")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/facebook"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Support")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("Help")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/bpmn",
      "target": "_blank"
    }
  }, [_vm._v("BPMN")])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "active item",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/videos"
    }
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "ui item"
  }, [_vm._v("\n        Logout\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    on: {
      "click": _vm.showSingInModal
    }
  }, [_vm._v("Sing In")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    on: {
      "click": _vm.showSingInModal
    }
  }, [_vm._v("Sing Up")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui main text container"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui right aligned category search item"
  }, [_c('div', {
    staticClass: "ui inverted transparent icon input"
  }, [_c('input', {
    staticClass: "prompt",
    attrs: {
      "type": "text",
      "placeholder": "Search keyword..."
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "search link icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "results"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6856f2b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/App.vue
// module id = 54
// module chunks = 1 2